import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, shareReplay, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TermsResponse, TermsAcceptanceStatusResponse } from '../models/payload';
import { stripDuplicateTitleHeading } from '../utils/common-utils';
import { marked } from 'marked';

@Injectable({
  providedIn: 'root'
})
export class TermsService {

  private http = inject(HttpClient);
  private acceptanceStatusRequest$?: Observable<TermsAcceptanceStatusResponse>;

  getAcceptanceStatus(): Observable<TermsAcceptanceStatusResponse> {
    if (!this.acceptanceStatusRequest$) {
      this.acceptanceStatusRequest$ = this.http
        .get<TermsAcceptanceStatusResponse>(environment.baseUrl + 'terms/acceptance-status')
        .pipe(
          catchError((err) => {
            this.acceptanceStatusRequest$ = undefined;
            return throwError(() => err);
          }),
          shareReplay({ bufferSize: 1, refCount: false })
        );
    }

    return this.acceptanceStatusRequest$;
  }

  getTerms(): Observable<TermsResponse> {
    return this.http.get<TermsResponse>(environment.baseUrl + 'terms').pipe(
      map((response) => {
        if (response.contentType === 'text/markdown') {
          const contentWithoutDuplicateTitle = stripDuplicateTitleHeading(response.content, response.title);
          return {
            ...response,
            content: marked(contentWithoutDuplicateTitle) as string
          };
        }
        return response;
      })
    );
  }

  acceptTerms(): Observable<void> {
    return this.http.put<void>(environment.baseUrl + 'terms/acceptance', { accepted: true }).pipe(
      tap(() => {
        this.acceptanceStatusRequest$ = undefined;
      })
    );
  }
}
